/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import _ from "underscore";

// TODO - This code is partly duplicated in marker-layer.js and layers.js
// Ideally would be good to use this as a generic base to those classes.

function layer(map, options) {
	options = options || {};
	options.density = options.density || 0;

	var enabled = true;
	var displayedTiles = {};

	function addTile(tile) {
		if(typeof options.addTile === "function") {
			tile  = options.addTile(tile) || tile;
		}
		return tile;
	}

	function removeTile(tile) {
		if(typeof options.removeTile == "function") {
			options.removeTile(tile);
		}
	}

	function updateOverlay() {
		var tiles = enabled ? tilesInView() : {};

		var tilesToAdd = _.difference(_.keys(tiles), _.keys(displayedTiles));
		var tilesToRemove = _.difference(_.keys(displayedTiles), _.keys(tiles));

		_.each(tilesToAdd, function(key) {
			displayedTiles[key] = addTile(tiles[key]);
		});
		_.each(tilesToRemove, function(key) {
			removeTile(displayedTiles[key]);
			delete displayedTiles[key];
		});
	}

	function refresh() {
		if(!map.getProjection()) {
			return;
		}

		_.each(displayedTiles, function(tile, key) {
			removeTile(tile);
		});
		displayedTiles = {};

		updateOverlay();
	}

	function tilesInView() {
		var proj = map.getProjection();
		if(proj == null) {
			return {};
		}
		var z = map.getZoom();
		var sw = proj.fromLatLngToPoint(map.getBounds().getSouthWest());
		var ne = proj.fromLatLngToPoint(map.getBounds().getNorthEast());
		var x, y;

		if(options.maxZoom && z > options.maxZoom) return {};
		if(options.minZoom && z < options.minZoom) return {};

		if(options.maxTileZ) {
			z = Math.min(z, options.maxTileZ);
		}

		// Discrete zoom levels
		// z = Math.max(z - 2, 1);
		// z = _.find([13,9,5,1], function(a) { return z >= a })

		z = Math.min(z + options.density, 18);

		var zz = Math.pow(2,z);

		if(sw.x > ne.x) sw.x -= 256;

		var scale = zz / 256;

		sw.x *= scale; sw.y *= scale;
		ne.x *= scale; ne.y *= scale;

		var tiles = {};
		for(x = Math.floor(sw.x); x < Math.ceil(ne.x); x++) {
			for(y = Math.floor(ne.y); y < Math.ceil(sw.y); y++) { // y is flipped
				var tx = (x + zz) % zz;
				var key = tx + "," + y + "," + z;
				tiles[key] = {
					x: tx,
					y: y,
					z: z,
					key: key
				};
			}
		}

		return tiles;
	}

	google.maps.event.addListener(map, 'bounds_changed', updateOverlay);

	function removeLayer() {
		google.maps.event.removeListener(map, 'bounds_changed', updateOverlay);
		enabled = false;
		updateOverlay();
	}

	return {
		refresh: refresh,
		remove: removeLayer
	};
}

export default layer;